import { FC } from "react";
import { Checkbox, Form } from "antd";
import { renderLabel } from "./utils";
import { createStyles } from "antd-style";

type CheckboxGroupProps = {
  value?: string[];
  onChange?: (value: string[]) => void;
  valuesMap: Map<string | number, any[]>;
  filter: any;
};

const CheckboxGroup: FC<CheckboxGroupProps> = ({ valuesMap, filter }) => {
  return (
    <Form.Item name={filter.key}>
      <Checkbox.Group className="flex w-full flex-col items-start gap-1">
        {Array.from(valuesMap).map(([val, elements]) => (
          <Checkbox
            key={val.toString()}
            value={val}
            className="w-full! whitespace-nowrap"
            classNames={{ root: "w-full!", label: "w-full!" }}
          >
            <div className="flex w-full items-center justify-between">
              <span>{renderLabel(val, filter)}</span>
              <span className="text-font-minimal">({elements.length})</span>
            </div>
          </Checkbox>
        ))}
      </Checkbox.Group>
    </Form.Item>
  );
};

export default CheckboxGroup;
